// removed by extract-text-webpack-plugin
module.exports = {"form":"___styles__form___QHig6"};


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/Account/styles.less
// module id = 555
// module chunks = 0